import { apiSlice } from "../api/apiSlice";

export const noticiasApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    noticias: builder.query({
      query: () => 'noticias',
      keepUnusedDataFor: 10,
      providesTags: (result, error, arg)=>[
        {type:'Noticias', id: 'LIST'},
      ]
    }),
    addNoticia: builder.mutation({
      query: (newNoticia)=>({
        url: 'noticias',
        method: 'post',
        body: newNoticia
      }),
      invalidatesTags: ["Noticias"]
    }),
    editNoticia: builder.mutation({
      query: (newNoticia)=>({
        url: 'noticias',
        method: 'put',
        body: newNoticia
      }),
      invalidatesTags: ["Noticias"]
    }),
    deleteNoticias: builder.mutation({
      query: (noticiasIds)=>({
        url: 'noticias',
        method: 'delete',
        body: noticiasIds
      }),
      invalidatesTags: ["Noticias"]
    }),
  })
})

export const { useNoticiasQuery, useAddNoticiaMutation, useEditNoticiaMutation, useDeleteNoticiasMutation } = noticiasApi;